const CACHE_VERSION_STORAGE_KEY = 'devsuiteCacheVersion'
const STOCK_CACHE_VERSION_STORAGE_KEY = 'devsuiteStockCacheVersion'

export function removeCacheVersion(): void {
  localStorage.removeItem(CACHE_VERSION_STORAGE_KEY)
  localStorage.removeItem(STOCK_CACHE_VERSION_STORAGE_KEY)
}

export function getCacheVersion(): string {
  try {
    const value = localStorage.getItem(CACHE_VERSION_STORAGE_KEY)
    return value ?? ''
  } catch {
    return ''
  }
}

export function setCacheVersion(version: string): void {
  localStorage.setItem(CACHE_VERSION_STORAGE_KEY, version)
}

export function getStockCacheVersion(): string {
  try {
    const value = localStorage.getItem(STOCK_CACHE_VERSION_STORAGE_KEY)
    return value ?? ''
  } catch {
    return ''
  }
}

export function setStockCacheVersion(version: string): void {
  localStorage.setItem(STOCK_CACHE_VERSION_STORAGE_KEY, version)
}
